// Petitions about Oleshky, listed under "Sign" on the left bank (Drone Siege) page.
// `titleKey`: translation key of the title (under leftBank.petitions); `by`: who runs the petition,
// shown after the link as plain text
export const oleshkyPetitions: { titleKey: string; href: string; by?: string }[] = [
  {
    titleKey: 'leftBank.petitions.euParliament',
    href: 'https://www.europarl.europa.eu/petitions/en/petition/subscription/subscriptionById/form/39495',
  },
  {
    titleKey: 'leftBank.petitions.ukParliament',
    href: 'https://petition.parliament.uk/petitions/782668',
  },
]
